export const texts = {
  empty: { de: 'Es gibt noch keine Aktivitäten oder Kommentare', en: 'There are no activities or comments yet' },
  loadMore: { de: 'Weitere laden', en: 'Load more' },
  comment: { de: 'Kommentieren', en: 'Comment' },
  commentPlaceholder: { de: 'Kommentieren', en: 'Comment' },
  mentionPlaceholder: { de: '@ eingeben, um Personen zu erwähnen', en: 'Type @ to mention people' }
};
